"use strict";

exports.__esModule = true;
exports.CreateTicketWatcherRuleScreen = CreateTicketWatcherRuleScreen;
var _react = _interopRequireDefault(require("react"));
var _Core = require("../../Core");
var _App = require("../../App");
var _TicketWatcherRuleForm = require("../TicketWatcherRuleForm");
var _System = require("../../../System");
var _constants = require("../constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function CreateTicketWatcherRuleScreen(props) {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var defaultDaysOfTheWeek = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
  return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
    title: translate("CreateTicketWatcherRuleScreen.title", "Create Watcher Rule")
  }, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
    title: translate("CreateTicketWatcherRuleScreen.navbar.title", "Create Watcher Rule")
  }), /*#__PURE__*/_react["default"].createElement(_TicketWatcherRuleForm.TicketWatcherRuleForm, {
    initialValues: {
      name: "",
      enabled: true,
      from: "00:00",
      to: "08:00",
      types: [],
      daysOfTheWeek: defaultDaysOfTheWeek,
      devices: [],
      deviceTags: [],
      users: [],
      emails: [],
      actions: []
    },
    onSubmit: function onSubmit(_ref) {
      var name = _ref.name,
        enabled = _ref.enabled,
        from = _ref.from,
        to = _ref.to,
        types = _ref.types,
        daysOfTheWeek = _ref.daysOfTheWeek,
        devices = _ref.devices,
        deviceTags = _ref.deviceTags,
        users = _ref.users,
        emails = _ref.emails,
        actions = _ref.actions;
      return props.collection.create({
        name: name,
        enabled: enabled,
        from: from,
        to: to,
        types: types,
        daysOfTheWeek: daysOfTheWeek,
        devices: devices.map(function (value) {
          return {
            type: "UUID",
            value: value
          };
        }).concat(deviceTags.map(function (value) {
          return {
            type: "TAG",
            value: value
          };
        })),
        watchers: users.map(function (value) {
          return {
            type: "USER",
            value: value
          };
        }).concat(emails.map(function (value) {
          return {
            type: "EMAIL",
            value: value
          };
        })),
        actions: actions.length <= 0 ? _constants.ACTION_TYPES.map(function (actionType) {
          return actionType.id;
        }) : actions
      }).then(function () {
        props.onSave();
        props.history.push((0, _System.getScreenLocation)("TicketWatcherRuleList"));
      });
    }
  }));
}